import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Loader from "../../../../../components/Loader";
import useAuth from "../../../../../components/hooks/useAuth";

const HEADER_HEIGHT = 70;

const ImportGroupCampaignModalComponent = ({
  showModalImport,
  setShowModalImport,loadGroupRequest
}) => {
  const navigate = useNavigate();
  const { sidebarOpen, getApi, postApi } = useAuth();
    const { id: campaignId } = useParams();

  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [groups, setGroups] = useState([]);
  const [selectedGroups, setSelectedGroups] = useState([]);

  // Mock de grupos com flag 'alreadyImported'
  useEffect(() => {
    if (showModalImport) {
    loadFetchGroupOnWp();
      setSelectedGroups([]);
      setSearchTerm("");
    }
  }, [showModalImport]);
  

    const loadFetchGroupOnWp = async () => {
    setLoading(true);
    try {
      let response = await getApi("/api/v1/campaign/fetchGroupsOnWhatsApp/" + campaignId, []);
      setGroups(response);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };


  const handleCloseModal = () => {
    setShowModalImport(false);
  };

  const toggleGroupSelection = (group) => {
    if (group.alreadyImported) return; // Impede seleção de já importados

    setSelectedGroups((prev) =>
      prev.includes(group.id) ? prev.filter((item) => item.id !== group.id) : [...prev, group]
    );
  };

  const handleSelectAll = () => {
    // Filtra apenas os grupos que podem ser selecionados (não importados e batem com a busca)
    const selectableGroups = filteredGroups.filter(g => !g.alreadyImported);
    
    if (selectedGroups.length === selectableGroups.length && selectableGroups.length > 0) {
      setSelectedGroups([]);
    } else {
      setSelectedGroups(selectableGroups.map((g) => g));
    }
  };

  const filteredGroups = groups.filter((g) =>
    g.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleImportar = async () => {
    if (selectedGroups.length === 0) {
      alert("Selecione pelo menos um grupo novo para importar");
      return;
    }

    setLoading(true);

    let response = await postApi("/api/v1/campaign/importGroupFromWhatsApp/" + campaignId, {
      whatsAppGroups: selectedGroups,
    });

    if (response.error || !response.success) {
      alert(response.error ? response.error.toString() : "Erro ao importar grupos.");
    } else {
      alert(`${selectedGroups.length} grupos importados com sucesso!`);
      loadGroupRequest();
      handleCloseModal();
    }

    setLoading(false);
  };

  if (!showModalImport) return null;

  return (
    <React.Fragment>
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          backgroundColor: "rgba(0,0,0,0.4)",
          backdropFilter: "blur(4px)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 3000,
          padding: "20px"
        }}
      >
        <div 
          style={{
            backgroundColor: "#fff",
            width: "100%",
            maxWidth: "500px",
            maxHeight: "85vh",
            borderRadius: "16px",
            boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
            overflow: "hidden",
            position: "relative",
            display: "flex",
            flexDirection: "column",
            animation: "modalSlideIn 0.3s ease-out"
          }}
        >
          {/* Header */}
          <div style={{
            padding: "20px 24px",
            borderBottom: "1px solid #f0f0f0",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center"
          }}>
            <div>
              <h5 style={{ margin: 0, fontSize: "18px", fontWeight: "700", color: "#333" }}>
                Importar Grupos
              </h5>
              <span style={{ fontSize: "12px", color: "#888" }}>
                {selectedGroups.length} selecionado(s) para importar
              </span>
            </div>
            <button 
              onClick={handleCloseModal}
              style={{ background: "none", border: "none", fontSize: "24px", cursor: "pointer", color: "#bbb", lineHeight: 1 }}
            >
              &times;
            </button>
          </div>

          {/* Busca e Seleção Geral */}
          <div style={{ padding: "16px 24px", borderBottom: "1px solid #f9f9f9" }}>
            <input 
              type="text"
              placeholder="Buscar grupo..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{
                width: "100%",
                padding: "10px 14px",
                borderRadius: "8px",
                border: "1px solid #eee",
                fontSize: "14px",
                outline: "none",
                marginBottom: "12px",
                backgroundColor: "#fcfcfc"
              }}
            />
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <button 
                onClick={handleSelectAll}
                style={{
                  background: "none",
                  border: "none",
                  color: "#51a197",
                  fontSize: "13px",
                  fontWeight: "600",
                  cursor: "pointer",
                  padding: 0
                }}
              >
                {selectedGroups.length > 0 && selectedGroups.length === filteredGroups.filter(g => !g.alreadyImported).length 
                  ? "Desmarcar todos" 
                  : "Selecionar grupos novos"}
              </button>
              <span style={{ fontSize: "11px", color: "#aaa" }}>
                Ignorando grupos já importados
              </span>
            </div>
          </div>

          {/* Lista de Grupos (Scrollable) */}
          <div style={{ 
            padding: "8px 12px", 
            overflowY: "auto", 
            flex: 1,
            backgroundColor: "#fafafa"
          }}>
            {filteredGroups.length > 0 ? filteredGroups.map((group) => (
              <div 
                key={group.id}
                onClick={() => toggleGroupSelection(group)}
                style={{
                  display: "flex",
                  alignItems: "center",
                  padding: "12px",
                  margin: "4px 0",
                  borderRadius: "10px",
                  backgroundColor: group.alreadyImported ? "#f5f5f5" : (selectedGroups.find(x=> x.id==group.id) ? "#f0f9f8" : "#fff"),
                  border: group.alreadyImported ? "1px solid #eee" : (selectedGroups.find(x=> x.id==group.id) ? "1px solid #51a197" : "1px solid #eee"),
                  cursor: group.alreadyImported ? "not-allowed" : "pointer",
                  transition: "all 0.2s",
                  opacity: group.alreadyImported ? 0.7 : 1
                }}
              >
                {/* Checkbox / Status Icon */}
                <div style={{
                  width: "20px",
                  height: "20px",
                  borderRadius: "5px",
                  border: group.alreadyImported ? "none" : (selectedGroups.find(x=> x.id==group.id) ? "none" : "2px solid #ddd"),
                  backgroundColor: group.alreadyImported ? "#ddd" : (selectedGroups.find(x=> x.id==group.id) ? "#51a197" : "transparent"),
                  marginRight: "12px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center"
                }}>
                  {group.alreadyImported ? (
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#777" strokeWidth="4">
                       <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                  ) : selectedGroups.find(x=> x.id==group.id) && (
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="4">
                      <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                  )}
                </div>

                <div style={{ flex: 1 }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <span style={{ fontSize: "14px", fontWeight: "600", color: group.alreadyImported ? "#888" : "#333" }}>
                      {group.name}
                        
                    </span> 
                       
                   
                    {group.alreadyImported && (
                      <span style={{ 
                        fontSize: "10px", 
                        backgroundColor: "#eee", 
                        color: "#888", 
                        padding: "2px 6px", 
                        borderRadius: "4px",
                        fontWeight: "bold"
                      }}>
                        JÁ IMPORTADO
                      </span>
                    )}
                
                   
                    
                  </div>
                     <span style={{ fontSize: "10px", fontWeight: "600", color: group.alreadyImported ? "#888" : "#333" }}>
                        {group.description}
                    </span> 
                  <div style={{ fontSize: "11px", color: "#999" }}>{group.qtd_members} participantes</div>
                </div>
              </div>
            )) : (
              <div style={{ textAlign: "center", padding: "30px", color: "#ccc", fontSize: "14px" }}>
                Nenhum grupo encontrado.
              </div>
            )}
          </div>

          {/* Footer */}
          <div style={{
            padding: "16px 24px",
            display: "flex",
            gap: "12px",
            justifyContent: "flex-end",
            borderTop: "1px solid #f0f0f0"
          }}>
            <button
              type="button"
              onClick={handleCloseModal}
              style={{
                padding: "10px 20px",
                borderRadius: "8px",
                border: "1px solid #ddd",
                background: "#fff",
                color: "#666",
                fontWeight: "600",
                cursor: "pointer"
              }}
            >
              Cancelar
            </button>

            <button
              type="button"
              onClick={handleImportar}
              disabled={selectedGroups.length === 0 || loading}
              style={{
                padding: "10px 24px",
                borderRadius: "8px",
                border: "none",
                background: (selectedGroups.length === 0 || loading) ? "#ccc" : "#005c53",
                color: "#fff",
                fontWeight: "bold",
                cursor: (selectedGroups.length > 0 && !loading) ? "pointer" : "not-allowed",
                transition: "all 0.2s"
              }}
            >
              {loading ? "Processando..." : `Importar ${selectedGroups.length} Grupos`}
            </button>
          </div>

          {loading && (
            <div style={{
              position: "absolute",
              top: 0, left: 0, right: 0, bottom: 0,
              display: "flex", alignItems: "center", justifyContent: "center",
              background: "rgba(255,255,255,0.7)",
              zIndex: 10
            }}>
              <Loader />
            </div>
          )}
        </div>
      </div>

      <style>
        {`
        @keyframes modalSlideIn {
          from { opacity: 0; transform: scale(0.95) translateY(10px); }
          to { opacity: 1; transform: scale(1) translateY(0); }
        }

        @media (max-width: 768px) {
          .d-flex.flex-column.flex-shrink-0.text-white {
            position: fixed !important;
            left: 0 !important;
            top: 0 !important;
            height: 100vh !important;
            width: 56px !important;
            z-index: 3000 !important;
            background: #277fa1 !important;
          }
        }
        `}
      </style>
    </React.Fragment>
  );
};

export default ImportGroupCampaignModalComponent;